import React, { useCallback, useEffect, useState } from 'react';

import { useDropzone } from 'react-dropzone';

import { useI18n } from 'Hooks';

import { DropZone, Error, ErrorModal, Overlay, Wrapper } from './styles';

export interface Props {
  accepted: string;
  handleFile: (file: any) => void;
  text?: string;
  dropText?: string;
  maxSize?: number;
  fontSize?: number | string;
  multiple?: boolean;
  height?: string;
  color?: string;
  bgColor?: string;
  borderColor?: string;
  width?: string;
  icon?: any;
}

const DropFile: React.FunctionComponent<Props> = ({
  accepted,
  handleFile,
  borderColor,
  text,
  dropText,
  maxSize = 8388608,
  fontSize = '14',
  multiple = false,
  height = '60px',
  bgColor = 'transparent',
  color = '#1c232c',
  width = '300px',
  icon,
}) => {
  const [showErrorModal, setShowErrorModal] = useState(false);
  const { t } = useI18n();

  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    if (fileRejections.length || acceptedFiles.length === 0) {
      return;
    }

    const AssignedPreviews = acceptedFiles.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      }),
    );

    handleFile(AssignedPreviews);
  }, []);

  const { getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({
    onDrop,
    accept: accepted,
    multiple: multiple,
    maxSize: maxSize,
  });

  useEffect(() => {
    if (fileRejections.length) {
      setShowErrorModal(true);
    } else {
      setShowErrorModal(false);
    }
  }, [fileRejections]);

  return (
    <Wrapper>
      <DropZone
        {...getRootProps()}
        color={color}
        bgColor={bgColor}
        borderColor={borderColor}
        height={height}
        width={width}
        fontSize={fontSize}>
        <input {...getInputProps()} />
        {icon && icon}
        {isDragActive ? (
          <p>{dropText || t('General.DropFileDropText')}</p>
        ) : (
          <p>{text || t('General.DropFileText')}</p>
        )}
      </DropZone>

      {showErrorModal && (
        <>
          <Overlay onClick={() => setShowErrorModal(false)} />
          <ErrorModal>
            {fileRejections.map((reject, i) => (
              <Error key={i}>{reject.file.name + ' - ' + reject.errors[0].message}</Error>
            ))}
          </ErrorModal>
        </>
      )}
    </Wrapper>
  );
};

export default DropFile;
